import Icon from './NavIcon';

const PrimeIcon = (props) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
    color="var(--color-i-violet-15)"
    path="M3.55728 4.61583C7.82387 3.91679 12.1764 3.91679 16.443 4.61583C17.5331 4.79466 18.3336 5.73676 18.3336 6.84142V13.1442C18.3336 14.3465 17.4193 15.3522 16.2223 15.4664L13.1764 15.7574C11.0637 15.9591 8.93657 15.959 6.82388 15.7574L3.77798 15.4664C2.58104 15.3522 1.66666 14.3465 1.66666 13.1442V6.84142C1.66675 5.73665 2.46706 4.79453 3.55728 4.61583ZM8.98892 7.54064C8.55577 7.38884 8.09846 7.67867 8.0397 8.12071C7.87579 9.35652 7.87579 10.6437 8.0397 11.8795C8.09863 12.3215 8.5558 12.6105 8.98892 12.4586L9.21548 12.3795C10.4554 11.9441 11.6182 11.3163 12.6588 10.5201C13.0027 10.2566 13.003 9.74247 12.6588 9.47911C11.6182 8.68296 10.4554 8.05613 9.21548 7.62071L8.98892 7.54064Z"
  />
);

export default PrimeIcon;
